module.exports = __webpack_public_path__ + "img/close_camera.00fda07c.svg";